/** Tabbed product showcase — the real interface, larger. */
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AttendanceReplica, KioskReplica, PayrollReplica, RotaReplica, StaffReplica } from '@/components/landing/ProductReplicas';

const TABS = [
  { value: 'rota', label: 'Rota Builder', Replica: RotaReplica },
  { value: 'kiosk', label: 'Kiosk', Replica: KioskReplica },
  { value: 'attendance', label: 'Attendance', Replica: AttendanceReplica },
  { value: 'payroll', label: 'Payroll', Replica: PayrollReplica },
  { value: 'staff', label: 'Staff', Replica: StaffReplica },
];

export function ShowcaseSection() {
  return (
    <section className="scroll-mt-24 [content-visibility:auto]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl font-display font-semibold tracking-tight" data-testid="marketing-showcase-heading">
            One platform. Less admin.
          </h2>
          <p className="mt-3 text-base text-[color:var(--brand-text-muted)] max-w-xl mx-auto">
            The same screens you and your team will use every day.
          </p>
        </div>
        <Tabs defaultValue="rota" className="mt-8">
          <TabsList className="flex flex-wrap justify-center h-auto gap-1 bg-[color:var(--brand-bg-2)] mx-auto" data-testid="marketing-showcase-tabs">
            {TABS.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value} className="rounded-lg px-3 sm:px-4 py-2" data-testid={`marketing-showcase-tab-${tab.value}`}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {TABS.map((tab) => (
            <TabsContent key={tab.value} value={tab.value} className="mt-6">
              <div className="max-w-3xl mx-auto">
                <tab.Replica className="shadow-[0_24px_60px_rgba(31,35,40,0.10)]" />
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
}
